import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import SupportImage from './SupportImage';
import './Support.scss';

const getToLink = (id) => {
  let to = `/support-centre/${id}`;
  if (id === 'hardware') {
    to = `/support-centre/category/${id}`;
  }
  return to;
};

const SupportCategory = (props) => {
  const { id, title, description, uri } = props;
  const to = getToLink(id);
  if (uri) {
    return (
      <div className="support-category" id={id}>
        <a className="support-link" href={uri}>
          <div className="support-image-wrapper">
            <SupportImage id={id} />
          </div>
          <h4 className="support-link-title">{title}</h4>
          <p className="support-link-description">{description}</p>
        </a>
      </div>
    );
  }
  return (
    <div className="support-category" id={id}>
      <Link className="support-link" to={to}>
        <div className="support-image-wrapper">
          <SupportImage id={id} />
        </div>
        <h4 className="support-link-title">{title}</h4>
        <p className="support-link-description">{description}</p>
      </Link>
    </div>
  );
};

SupportCategory.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  uri: PropTypes.string
};

export default SupportCategory;



/** WEBPACK FOOTER **
 ** ./src/components/Support/SupportCategory.js
 **/